/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const UserIdle = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M12 10.6c.7 0 1.4.5 1.5 1.3l.6 4.4c.1.8-.5 1.6-1.3 1.7-.8.1-1.6-.5-1.7-1.3l-.4-3.2H7.4c-.7 0-1.2-.4-1.4-1.1-.1-.1-.1-.2-.2-.4L4.6 7.8c-.2-.7.2-1.6 1-1.8s1.6.2 1.8 1l1 3.5h3.4c.1.1.2.1.2.1zm1.7-8.5c2.1 0 3.7 1.7 3.7 3.7s-1.7 3.7-3.7 3.7S10 7.9 10 5.8s1.6-3.7 3.7-3.7zm2.1 4.4v-.4c0-.2-.1-.3-.3-.3h-1.2V4.1c0-.2-.1-.3-.3-.3h-.4c-.2 0-.3.1-.3.3v2.4c0 .2.1.3.3.3h1.9c.1 0 .3-.2.3-.3zM2.6 9.1c-.1-.4.1-.8.5-.9s.8.1.9.5c.3 1.2.6 2.3.8 3.3.5 1.7 1 2.3 2.3 2.4.7.1 1.4.1 2.1 0 .4 0 .8.3.8.7 0 .4-.3.8-.7.8-.9.1-1.7.1-2.5 0-2-.2-2.9-1.2-3.5-3.5-.2-1.1-.5-2.2-.7-3.3zM6 5.4c-.9.4-2 0-2.4-.9s0-2 .9-2.4 2 0 2.4.9c.4.9 0 2-.9 2.4z" />
  </svg>
);

export default extendIcon(UserIdle);
